import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { Layout } from "../components/common";
import { MetaData } from "../components/common/meta";
import createPostFeeds from "../components/Posts";
import createPostFeedsCount from "../components/PostsCount";
import { withPrefix } from "gatsby";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import { LoadMore } from "../components/common/LoadMore";
import queryString from 'query-string';
import { navigate } from "gatsby";
import { SearchInput } from "../components/common/utilities";
import _ from 'lodash';

const DEFAULT_SHOW_POSTS = 12;

/**
 * Single page (/:slug)
 *
 * This file renders a single page and loads all the content.
 *
 */
class Page extends Component {
    constructor(props) {
        super(props);
        let params = queryString.parse(props.location.search)
        this.state = {
            showPosts: DEFAULT_SHOW_POSTS,
            showButton: true,
            filter: params.filter ? params.filter : "All",
            industry: params.industry ? params.industry : "All",
            industryF: "",
            country: params.country ? params.country : "All",
            countryF: "",
            productF: "",
            style: params.style ? params.style : "All",
            styleF: "",
            community: params.community ? params.community : "All",
            communityF: "",
            productList: [{product:'#All',id: -1}],
            accordionInner: 0,
            isFilterOpen: true,
            search: "",
        };

        this.handleClick = this.handleClick.bind(this);
        this.setIndustry = this.setIndustry.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.setFilterF = this.setFilterF.bind(this);

        this.dropdown = React.createRef();
        this.dropdown1 = React.createRef();
        this.dropdownBgLayer = React.createRef();

        this.accordion = React.createRef();
        this.searchInputRef = React.createRef();
        this.masonaryRef = React.createRef();
        this.loaderRef = React.createRef();

    }

    handleClick() {
        this.setState({
            showPosts: this.state.showPosts + 4,
            showButton: true,
        });
    }

    updateQueryParms(param) {
        const query =  queryString.parse(this.props.location.search);
        const searchParams = queryString.stringify({...query, ...param});
        navigate(`?${searchParams}`);
    }

    componentDidUpdate(prevProps, prevState) {
        const { filter, industry, community, country} = this.state;

        if( country !== prevState.country || industry !== prevState.industry || filter !== prevState.filter || community !== prevState.community ) {
            const param = {};
            param.country = country;
            param.industry = industry;
            param.filter = filter;
            param.community = community;
            this.updateQueryParms(param);
        }
    }

    setFilter(filter) {
        this.setState({ filter, industry: "All", country: "All", productF:''});

        if (this.dropdown1.current) {
            this.dropdown1.current.style.display = "none";
        }
        if (this.dropdownBgLayer.current) {
            this.dropdownBgLayer.current.style.display = "none";
        }
    }

    setIndustry(industry) {
        if (industry === this.state.industry) {
            this.setState({ industry, country: "All", industryF: '' });
        } else {
            this.setState({ industry, industryF: '' });
        }

        if (this.dropdown.current) {
            this.dropdown.current.style.display = "none";
        }
        if (this.dropdownBgLayer.current) {
            this.dropdownBgLayer.current.style.display = "none";
        }
    }

    setFilterF(name, value) {
        if(name === 'search' && value){
            this.setState({
                showPosts: DEFAULT_SHOW_POSTS,
                showButton: true,
            });
        }

        this.setState({ [name]:value });
    }

    setFilterV(name, value, dropdownRef) {
        this.setState({ [name]: value, [name+'F']:'' });
        dropdownRef.current.style.display='none';
        if (this.dropdownBgLayer.current) {
            this.dropdownBgLayer.current.style.display = "none";
        }

    }

    getStyleList = () => {
        let list = [
            "Minimal",
            "Earthy",
            "Colourful",
            "Simple",
            "Patterns",
            "Geometric",
        ];
        return list;
    }
    getCommunityList = () => {
        let list = [
            "Eco Alliance",
            "Creative Community",
            "Events Hub",
            "Industry Experts",
            "itsnoissue",
        ];
        return list;
    }

    getTagName(tag) {
        if (tag === "KidsWear") {
            return "Kids Wear";
        }

        if (tag === "HomeandGift") {
            return "Home and Gift";
        }

        if (tag === "HealthandBeauty") {
            return "Health and Beauty";
        }
        return tag;
    }

    getProductName(product) {
        const { data } = this.props;
        const productsDataContentful = data.contentfulProducts.totalCount === 1 ? data.contentfulProducts.edges[0].node.products : [];
        productsDataContentful.forEach((val) => {
            if (val.wildSectionTagSlug && val.wildSectionTagSlug.includes(product)) {
                product = val.displayName;
            }
        });
        return product;
    }

    getProductTag() {
        const { data } = this.props;
        const productsDataContentful = data.contentfulProducts.totalCount === 1 ? data.contentfulProducts.edges[0].node.products : [];
        const product = [];
        productsDataContentful.forEach((val) => {
            val.wildSectionTagSlug && product.push(val.wildSectionTagSlug?.replace(/hash-/i, '#'));
        });
        return product;
    }

    filterControl = (filterItem, filterName, page, id) => (
        <a
            href={withPrefix(`/${page.slug}?filter=${filterItem}`)}
            onClick={(e) => {
                e.preventDefault();
                this.setFilter(filterItem);
            }}
            key={id}
            className={`${this.state.filter === filterItem ? "active" : ""}`}
        >
            {filterName}
        </a>
    );

    getProductList = (tags)=>{
        tags.forEach((product, id) =>{
            if(product.charAt(0) === "#" && this.getProductTag().includes(product)){
            let temp = {product, id};
            this.setState(prevState => ({productList: [...prevState.productList, temp]}))
        }
        });
    }
    clearFilter = (name) => {

    }
    filters = (filtersList, page) =>
        filtersList.map((filter, id) =>
            filter === "noissue Stickers"
                ? this.filterControl("noissueSticker", filter, page, id)
                : filter === "Branding & Creative"
                ? this.filterControl("branding", filter, page, id)
                : this.filterControl(filter.replace(" ", ""), filter, page, id)
        );

    showHideDropDown = (dropdowns, current) => {
        if(current){
            dropdowns.forEach(element => {
                if(element !== current)
                    element.current.style.display = "none";
                });
            current.current.style.display=current.current.style.display === 'none' ? 'block':'none';
            this.dropdownBgLayer.current.style.display= 'block';
        } else {
            dropdowns.forEach(element => {
                element.current.style.display = "none";
            });
            this.dropdownBgLayer.current.style.display= 'none';
        }
    }
    toggelAccordion = () => {
        if(!this.state.isFilterOpen){
            this.accordion.current.style.maxHeight = this.accordion.current.scrollHeight + 'px';
            this.accordion.current.style.overflow = 'unset';
            this.accordion.current.style.opacity = 1;
        } else {
            this.accordion.current.style.maxHeight = 0;
            this.accordion.current.style.overflow = 'hidden';
            this.accordion.current.style.opacity = 0;
        }

        this.setState({isFilterOpen: !this.state.isFilterOpen});

            // setTimeout(()=>{
        //     this.accordion.current.style.display = this.accordion.current.style.display === 'none' ? 'block':'none';
        // },2000)
        // this.accordion.current.style.display = this.accordion.current.style.display === 'none' ? 'block':'none';
    }
    componentDidMount(){
        const { data } = this.props;
        const posts = data.allGhostPost.edges;
        let tags = [];
        posts.forEach((post) => {
            const postTags = post.node.tags;

            if (postTags && postTags.length > 0) {
                const isPost = Object.keys(postTags).some(
                    (k) => postTags[k].slug === "hash-post"
                );

                if (isPost) {
                    postTags.forEach((tag) => {
                        if (tag.slug !== "hash-post") {
                            tags.push(tag.name);
                        }
                    });
                }
            }
        });

        tags = [...new Set(tags)];
        this.getProductList(tags);
    }

    commonFilter(posts, searchParam){
        return posts.filter((post) => {
            if(post.node?.tags && searchParam!=='All'){
                let item = post.node.tags.find((tag) => {
                    let tName = tag.name.split(' ').join('').toLowerCase();
                    let tSeries = searchParam?.split(' ').join('').toLowerCase();
                    if(tName.includes(tSeries) )
                        return true;
                     }
                     )
                return !!item;
            }
            return true;
        });
    }

    searchFilter(key, array, tags){
        let filteredC = this.commonFilter(array, this.state.community);
        return filteredC.filter(post => {
            if(post.node.title && post.node.title.toLocaleLowerCase().includes(key.toLocaleLowerCase()))
                return true;
            if(post.node.plaintext && post.node.plaintext.toLocaleLowerCase().includes(key.toLocaleLowerCase()))
                return true
            if(post.node.excerpt && post.node.excerpt.toLocaleLowerCase().includes(key.toLocaleLowerCase()))
            return true

             return false;
        })
    }

    render() {
        const { data, location } = this.props;
        const { showPosts, filter, industry, country, productList, style, styleF, community, communityF, isFilterOpen, search } = this.state;

        const page = data.ghostPage;
        const blogposts = data.allGhostPost.edges;
        const videoPosts = data.videos.nodes;
        let allPosts = [];
        if(videoPosts && videoPosts.length > 0 ) {
            allPosts = videoPosts.map(item => {
                const _item = {...item,
                    published_at: item.originalPublishedDate,
                    excerpt: item.excerpt.excerpt,
                    tags: [{name:item.channel.name, slug:item.channel.slug}],
                    type: 'video'}
                return {node: _item}
            })
        }
        allPosts = [...allPosts, ...blogposts];

        allPosts.sort((a,b) => {
            const date1 = new Date(a.node.published_at);
            const date2 = new Date(b.node.published_at);
            return  date2 - date1;
        })
        const posts = allPosts;
        let tags = [];

        posts.forEach((post) => {
            const postTags = post.node.tags;

            if (postTags && postTags.length > 0) {
                const isPost = Object.keys(postTags).some(
                    (k) => postTags[k].slug === "hash-post"
                );

                if (isPost) {
                    postTags.forEach((tag) => {
                        if (tag.slug !== "hash-post") {
                            tags.push(tag.name);
                        }
                    });
                }
            }
        });

        tags = [...new Set(tags)];
        let finalNumberOfSection = 4;
        let finalSearchRelatedThing = false;
        let pageSlugVal = page.slug;
        let filterPosts = this.searchFilter(search, posts, tags)
        let maxPosts = 4;
        if(filterPosts.length < 27)
            maxPosts = 2;
        let onlyPostLength = Math.ceil(filterPosts.length / maxPosts);
        let maxLength = onlyPostLength < showPosts ? onlyPostLength : showPosts;

        let postLength = createPostFeedsCount(
            filterPosts,
            finalNumberOfSection,
            showPosts,
            finalSearchRelatedThing,
            filter,
            industry,
            country,
            pageSlugVal,
            maxPosts,
        );

        let hasMore = postLength > maxLength*maxPosts;
        const dropdowns = [this.dropdown,this.dropdown1];

        if(this.masonaryRef?.current?.props?.children?.length > 0 || (!postLength && this.loaderRef?.current)){
            this.loaderRef.current.style.display = 'none';
        }

        return (
            <>
                <div ref={this.dropdownBgLayer} className="dropdown-layer" onClick={(e) => {e.preventDefault();e.stopPropagation();this.showHideDropDown(dropdowns, null)}}/>
                <MetaData data={data} location={location} type="website" />
                <Layout bodyClass={`page ${page.slug} elbrus-headless`}>
                    <div className="container">
                        <article className="content">
                            <div className="header-inspo">
                            <div>
                                <div className="accordion">
                                <button className={`filter-by ${!isFilterOpen?'filter-inverse':''}`} onClick={()=>this.toggelAccordion()}>
                                    <img  src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMi4wNjA4IDQuNDQ3NDJIOS4wMjgxNEM4LjY2OTgzIDMuMzY1MTYgNy42NjMyNyAyLjU4MzI1IDYuNDc5ODEgMi41ODMyNUM1LjI5NjM0IDIuNTgzMjUgNC4yODk3OCAzLjM2NTE2IDMuOTMxNDggNC40NDc0MkgxLjg5NzE4QzEuNDI0NjIgNC40NDc0MiAxLjA0MTUgNC44MzcwNCAxLjA0MTUgNS4zMTc2M0MxLjA0MTUgNS43OTgyMSAxLjQyNDYyIDYuMTg3ODQgMS44OTcxOCA2LjE4Nzg0SDMuOTMxNTNDNC4yODk4NCA3LjI3MDA5IDUuMjk2NCA4LjA1MiA2LjQ3OTg2IDguMDUyQzcuNjYzMzMgOC4wNTIgOC42Njk4OSA3LjI3MDA5IDkuMDI4MTkgNi4xODc4NEgyMi4wNjA4QzIyLjUzMzQgNi4xODc4NCAyMi45MTY1IDUuNzk4MjEgMjIuOTE2NSA1LjMxNzYzQzIyLjkxNjUgNC44MzcwNCAyMi41MzM0IDQuNDQ3NDIgMjIuMDYwOCA0LjQ0NzQyWk02LjQ3OTgxIDYuMzExNThDNS45NDA5IDYuMzExNTggNS41MDI0NSA1Ljg2NTY5IDUuNTAyNDUgNS4zMTc2M0M1LjUwMjQ1IDQuNzY5NTcgNS45NDA5IDQuMzIzNjcgNi40Nzk4MSA0LjMyMzY3QzcuMDE4NzEgNC4zMjM2NyA3LjQ1NzE2IDQuNzY5NTcgNy40NTcxNiA1LjMxNzYzQzcuNDU3MTYgNS44NjU2OSA3LjAxODcxIDYuMzExNTggNi40Nzk4MSA2LjMxMTU4WiIgZmlsbD0iIzM5Mzk3MiIvPg0KPHBhdGggZD0iTTIyLjA2MDggMTEuMjgzNEgyMC4wMjY0QzE5LjY2ODEgMTAuMjAxMSAxOC42NjE1IDkuNDE5MTkgMTcuNDc4MSA5LjQxOTE5QzE2LjI5NDcgOS40MTkxOSAxNS4yODgxIDEwLjIwMTEgMTQuOTI5OCAxMS4yODM0SDEuODk3MThDMS40MjQ2MiAxMS4yODM0IDEuMDQxNSAxMS42NzMgMS4wNDE1IDEyLjE1MzZDMS4wNDE1IDEyLjYzNDIgMS40MjQ2MiAxMy4wMjM4IDEuODk3MTggMTMuMDIzOEgxNC45Mjk4QzE1LjI4ODEgMTQuMTA2IDE2LjI5NDcgMTQuODg3OSAxNy40NzgxIDE0Ljg4NzlDMTguNjYxNiAxNC44ODc5IDE5LjY2ODIgMTQuMTA2IDIwLjAyNjUgMTMuMDIzOEgyMi4wNjA4QzIyLjUzMzQgMTMuMDIzOCAyMi45MTY1IDEyLjYzNDIgMjIuOTE2NSAxMi4xNTM2QzIyLjkxNjUgMTEuNjczIDIyLjUzMzQgMTEuMjgzNCAyMi4wNjA4IDExLjI4MzRaTTE3LjQ3ODEgMTMuMTQ3NUMxNi45MzkyIDEzLjE0NzUgMTYuNTAwOCAxMi43MDE2IDE2LjUwMDggMTIuMTUzNkMxNi41MDA4IDExLjYwNTUgMTYuOTM5MiAxMS4xNTk2IDE3LjQ3ODEgMTEuMTU5NkMxOC4wMTcxIDExLjE1OTYgMTguNDU1NSAxMS42MDU1IDE4LjQ1NTUgMTIuMTUzNkMxOC40NTU1IDEyLjcwMTYgMTguMDE3MSAxMy4xNDc1IDE3LjQ3ODEgMTMuMTQ3NVoiIGZpbGw9IiMzOTM5NzIiLz4NCjxwYXRoIGQ9Ik0yMi4wNjA4IDE5LjQ4NjVIMTIuNjk0M0MxMi4zMzYgMTguNDA0MiAxMS4zMjk0IDE3LjYyMjMgMTAuMTQ1OSAxNy42MjIzQzguOTYyNDggMTcuNjIyMyA3Ljk1NTkxIDE4LjQwNDIgNy41OTc2MSAxOS40ODY1SDEuODk3MThDMS40MjQ2MiAxOS40ODY1IDEuMDQxNSAxOS44NzYxIDEuMDQxNSAyMC4zNTY3QzEuMDQxNSAyMC44MzczIDEuNDI0NjIgMjEuMjI2OSAxLjg5NzE4IDIxLjIyNjlINy41OTc2MUM3Ljk1NTkxIDIyLjMwOTIgOC45NjI0OCAyMy4wOTExIDEwLjE0NTkgMjMuMDkxMUMxMS4zMjk0IDIzLjA5MTEgMTIuMzM2IDIyLjMwOTIgMTIuNjk0MyAyMS4yMjY5SDIyLjA2MDhDMjIuNTMzNCAyMS4yMjY5IDIyLjkxNjUgMjAuODM3MyAyMi45MTY1IDIwLjM1NjdDMjIuOTE2NSAxOS44NzYxIDIyLjUzMzQgMTkuNDg2NSAyMi4wNjA4IDE5LjQ4NjVaTTEwLjE0NTkgMjEuMzUwN0M5LjYwNzAzIDIxLjM1MDcgOS4xNjg1OCAyMC45MDQ4IDkuMTY4NTggMjAuMzU2N0M5LjE2ODU4IDE5LjgwODcgOS42MDcwMyAxOS4zNjI4IDEwLjE0NTkgMTkuMzYyOEMxMC42ODQ4IDE5LjM2MjggMTEuMTIzMyAxOS44MDg2IDExLjEyMzMgMjAuMzU2N0MxMS4xMjMzIDIwLjkwNDcgMTAuNjg0OCAyMS4zNTA3IDEwLjE0NTkgMjEuMzUwN1oiIGZpbGw9IiMzOTM5NzIiLz4NCjwvc3ZnPg0K"
                                    alt="filter" className="filter-icon"/> Filter By</button>
                                    <div className="search">
                                        <input type="text" placeholder="Search Inspo..." name="query" value={search}
                                            onChange={(e) => {
                                            e.preventDefault();
                                            this.setFilterF( 'search' ,e.target.value);
                                        }}/>
                                    </div>
                                </div>
                            </div>
                            <div className="filters  panel" ref={this.accordion}>
                                <nav className="filter-controls filter-inspo">
                                    {page.slug === "biz-advice" ? (
                                        this.filters(
                                            [
                                                "Marketing",
                                                "Branding & Creative",
                                                "Sustainability",
                                            ],
                                            page
                                        )
                                    ) : (
                                        <div className="dropdown-wrapper">
                                            <div className="dropdown-header">
                                                <label className="dropdown-label">Products</label>
                                                <span className={`dropdown-clear ${this.state.filter === 'All'?'hide':''}`}
                                                 onClick={(e) => {
                                                     e.preventDefault();
                                                     this.setFilter('All');
                                                     }}>Clear</span>
                                            </div>
                                        <div className="has-dropdown">
                                            <button
                                                className="dropdown-button"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.showHideDropDown(dropdowns, this.dropdown1)
                                                }}
                                            >
                                                {this.getProductName(filter)}
                                            </button>
                                            <ul
                                                className="dropdown"
                                                ref={this.dropdown1}
                                            >
                                                <li key="0p">
                                                <SearchInput
                                                    value={this.state.productF}
                                                    setFilterF={this.setFilterF}
                                                    valueKey="productF"
                                                />
                                                </li>
                                                {productList.filter(item =>
                                                    item.product.toLocaleLowerCase().includes(this.state.productF.toLocaleLowerCase()))
                                                .map(
                                                    (item) =>(
                                                            <li key={item.id}>
                                                                <a
                                                                    href={withPrefix(
                                                                        `/${
                                                                            page.slug
                                                                        }?filter=${item.product.substr(
                                                                            1
                                                                        )}`
                                                                    )}
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        e.preventDefault();
                                                                        this.setFilter(item.product.substr(1));
                                                                    }}
                                                                    className={`${
                                                                        filter ===
                                                                        item.product.substr(
                                                                            1
                                                                        )
                                                                            ? "active"
                                                                            : ""
                                                                    }`}
                                                                >
                                                                    {this.getProductName(
                                                                        item.product.substr(
                                                                            1
                                                                        )
                                                                    )}
                                                                </a>
                                                            </li>
                                                        )
                                                )}
                                            </ul>
                                        </div>
                                        </div>
                                    )}

                                <div className="dropdown-wrapper">
                                    <div className="dropdown-header">
                                            <label className="dropdown-label">Industry</label>
                                            <span className={`dropdown-clear ${this.state.industry === 'All'?'hide':''}`}
                                                onClick={(e) => {
                                                e.preventDefault();
                                                this.setIndustry('All');
                                                }}>Clear</span>

                                    </div>
                                    <div className="has-dropdown">
                                        <button
                                            className="dropdown-button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.showHideDropDown(dropdowns, this.dropdown)
                                            }}
                                        >
                                            {this.state.industry}
                                        </button>
                                        <ul
                                            className="dropdown"
                                            ref={this.dropdown}
                                        >
                                            <li key="0b">
                                                <SearchInput
                                                    value={this.state.industryF}
                                                    setFilterF={this.setFilterF}
                                                    valueKey="industryF"
                                                  />
                                            </li>
                                            <li key="1b">
                                                <a
                                                    href={withPrefix(`/${page.slug}?filter=${filter}&industry=All`)}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        this.setFilterF('industry','All', this.dropdown);
                                                    }}
                                                    className={`${
                                                        industry === "All"
                                                            ? "active"
                                                            : ""
                                                    }`}
                                                >
                                                    All
                                                </a>
                                            </li>
                                            {tags.filter(item =>
                                                item.toLocaleLowerCase().includes(this.state.industryF.toLocaleLowerCase()))
                                                .sort(function (a, b) {
                                                    if (
                                                        a.charAt(0) === "#" &&
                                                        b.charAt(0) === "#"
                                                    ) {
                                                        return a
                                                            .substr(1)
                                                            .toLowerCase()
                                                            .localeCompare(
                                                                b
                                                                    .substr(1)
                                                                    .toLowerCase()
                                                            );
                                                    }
                                                    if (
                                                        a.charAt(0) === "#" &&
                                                        b.charAt(0) !== "#"
                                                    ) {
                                                        return a
                                                            .substr(1)
                                                            .toLowerCase()
                                                            .localeCompare(
                                                                b.toLowerCase()
                                                            );
                                                    }
                                                    if (
                                                        a.charAt(0) !== "#" &&
                                                        b.charAt(0) === "#"
                                                    ) {
                                                        return a
                                                            .toLowerCase()
                                                            .localeCompare(
                                                                b
                                                                    .substr(1)
                                                                    .toLowerCase()
                                                            );
                                                    }
                                                    if (
                                                        a.charAt(0) !== "#" &&
                                                        b.charAt(0) !== "#"
                                                    ) {
                                                        return a
                                                            .toLowerCase()
                                                            .localeCompare(
                                                                b.toLowerCase()
                                                            );
                                                    }

                                                    return 0;
                                                })
                                                .map(
                                                    (tag, id) =>
                                                        tag.charAt(0) === "#" &&
                                                        this.getProductTag().includes(
                                                            tag
                                                        ) !== true && (
                                                            <li key={id}>
                                                                <a
                                                                    href={withPrefix(`/${
                                                                        page.slug
                                                                    }?filter=${filter}&industry=${tag.substr(
                                                                        1
                                                                    )}`)}
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        e.preventDefault();
                                                                        this.setFilter(
                                                                            filter
                                                                        );
                                                                        this.setIndustry(
                                                                            tag.charAt(
                                                                                0
                                                                            ) ===
                                                                                "#"
                                                                                ? tag.substr(
                                                                                      1
                                                                                  )
                                                                                : tag
                                                                        );
                                                                    }}
                                                                    className={`${
                                                                        industry ===
                                                                        (tag.charAt(
                                                                            0
                                                                        ) ===
                                                                        "#"
                                                                            ? tag.substr(
                                                                                  1
                                                                              )
                                                                            : tag)
                                                                            ? "active"
                                                                            : ""
                                                                    }`}
                                                                >
                                                                    {this.getTagName(
                                                                        tag.charAt(
                                                                            0
                                                                        ) ===
                                                                            "#"
                                                                            ? tag.substr(
                                                                                  1
                                                                              )
                                                                            : tag
                                                                    )
                                                                        .split(
                                                                            " "
                                                                        )
                                                                        .map(
                                                                            (
                                                                                w
                                                                            ) =>
                                                                                w[0].toUpperCase() +
                                                                                w
                                                                                    .substr(
                                                                                        1
                                                                                    )
                                                                                    .toLowerCase()
                                                                        )
                                                                        .join(
                                                                            " "
                                                                        )}
                                                                </a>
                                                            </li>
                                                        )
                                                )}
                                        </ul>
                                    </div>
                                    </div>
                                </nav>
                            </div>
                            </div>
                            <ResponsiveMasonry
                                className='masonry-wrapper'
                                columnsCountBreakPoints={{350: 2, 750: 2, 900: 4}}
                            >
                                <div ref={this.loaderRef}>
                                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style={{color:'#2C1847'}}></i>
                                    <span class="sr-only">Loading...</span>
                                </div>

                                <Masonry ref={this.masonaryRef}>
                                {createPostFeeds(
                                    filterPosts,
                                    "",
                                    showPosts,
                                    false,
                                    filter,
                                    industry,
                                    country,
                                    page.slug,
                                    maxPosts,
                                    this.handleClick,
                                )}
                                </Masonry>
                            </ResponsiveMasonry>
                        </article>
                    </div>
                    {hasMore && <LoadMore
                        items={postLength}
                        itemsViewed={maxLength*maxPosts}
                        handleClick={this.handleClick}
                    />}
                    <div className="search-bottom">
                        <div><h1>Can’t find what you’re looking for?</h1></div>
                        <div>
                            <form
                                action={withPrefix('/search')}
                                method="GET"
                            >
                           <div className="search">
                                <input type="search" placeholder="Search The Wrap..." name="query" />
                                <button type="submit" ><img className="filter-dropdown-search-icon" src="data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjEzIiB2aWV3Qm94PSIwIDAgMTMgMTMiIHdpZHRoPSIxMyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PG1hc2sgaWQ9ImEiIGZpbGw9IiNmZmYiPjxwYXRoIGQ9Im0wIDEyLjk3Mzg2NDZ2LTEyLjk3Mzg2NDZoMTIuOTczNzI5MnYxMi45NzM4NjQ2eiIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9tYXNrPjxwYXRoIGQ9Im0yLjUzNDk4NjQ2IDguMjM2ODU0MTdjLS43NjE1ODMzMy0uNzYxNTgzMzQtMS4xODA5Njg3NS0xLjc3NDA5Mzc1LTEuMTgwOTY4NzUtMi44NTA5MjcwOSAwLTEuMDc2OTY4NzUuNDE5Mzg1NDItMi4wODkzNDM3NSAxLjE4MTEwNDE2LTIuODUwOTI3MDguNzYxNDQ3OTItLjc2MTU4MzMzIDEuNzczODIyOTItMS4xODA5Njg3NSAyLjg1MDc5MTY3LTEuMTgwOTY4NzUgMS4wNzY4MzMzMyAwIDIuMDg5NDc5MTcuNDE5Mzg1NDIgMi44NTEwNjI1IDEuMTgwOTY4NzUgMS41NzE5MTY2NyAxLjU3MTkxNjY3IDEuNTcxOTE2NjcgNC4xMjk2NjY2NyAwIDUuNzAxNzE4NzUtLjc2MTU4MzMzLjc2MTU4MzMzLTEuNzc0MjI5MTcgMS4xODA5Njg3NS0yLjg1MTA2MjUgMS4xODA5Njg3NS0xLjA3Njk2ODc1LjAwMDEzNTQyLTIuMDg5MzQzNzUtLjQxOTI1LTIuODUwOTI3MDgtMS4xODA4MzMzM20xMC4yNDA0NzkxNCAzLjU4MTA5MzczLTMuMTMzNDA2MjMtMy4xMzM0MDYyM2MxLjYzODU0MTYzLTIuMTExMTQ1ODQgMS40OTAxMjUwMy01LjE2OTM5NTg0LS40NDc2ODc1LTcuMTA2OTM3NS0xLjAxNzI1LTEuMDE3Mzg1NDItMi4zNjk5MjcwOC0xLjU3NzYwNDE3LTMuODA4NDU4MzMtMS41Nzc2MDQxNy0xLjQzODY2NjY3IDAtMi43OTEwNzI5Mi41NjAyMTg3NS0zLjgwODMyMjkyIDEuNTc3NjA0MTctMS4wMTczODU0MSAxLjAxNzI1LTEuNTc3NjA0MTYgMi4zNjk3OTE2Ni0xLjU3NzYwNDE2IDMuODA4NDU4MzNzLjU2MDM1NDE3IDIuNzkxMjA4MzMgMS41Nzc0Njg3NSAzLjgwODU5Mzc1YzEuMDE3Mzg1NDEgMS4wMTcyNDk5NSAyLjM2OTc5MTY2IDEuNTc3NDY4NzUgMy44MDg0NTgzMyAxLjU3NzQ2ODc1IDEuMjEwMzU0MTcgMCAyLjM1ODgyMjkyLS4zOTc4NTQyIDMuMjk5MTU2MjUtMS4xMjk1MTA0MmwzLjEzMjg2NDYxIDMuMTMzMDAwMDJjLjEzMjE2NjYuMTMyMTY2Ni4zMDU1LjE5ODI1LjQ3ODY5NzkuMTk4MjVzLjM0NjY2NjctLjA2NjA4MzQuNDc4ODMzMy0uMTk4MjVjLjI2NDQ2ODgtLjI2NDYwNDIuMjY0NDY4OC0uNjkzMzMzNCAwLS45NTc2NjY3IiBmaWxsPSIjMjYyNjY0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIG1hc2s9InVybCgjYSkiLz48L3N2Zz4=" alt="search"
                                /></button>
                            </div>
                            </form>
                        </div>
                    </div>
                    <div className="container-wrapper">

                    </div>
                </Layout>
            </>
        );
    }
}

Page.propTypes = {
    data: PropTypes.shape({
        ghostPage: PropTypes.shape({
            codeinjection_styles: PropTypes.object,
            title: PropTypes.string.isRequired,
            html: PropTypes.string,
            feature_image: PropTypes.string,
        }).isRequired,
    }).isRequired,
    location: PropTypes.object.isRequired,
};

export default Page;

export const postQuery = graphql`
    query($slug: String!, $limit: Int!, $skip: Int!) {
        ghostPage(slug: { eq: $slug }) {
            ...GhostPageFields
        }
        allGhostPost(
            sort: { order: DESC, fields: [published_at] }
            limit: $limit
            skip: $skip
        ) {
            edges {
                node {
                    ...GhostPostFields
                }
            }
        }
        videos: allContentfulVideo(
            sort: { fields: originalPublishedDate, order: DESC }
            filter: { node_locale: { eq: "en-US" } }
            limit: 1000
            skip: 0
        ) {
            nodes {
                id
                slug
                title
                url
                postSlug
                excerpt {
                    excerpt
                }
                originalPublishedDate
                published_at_pretty: originalPublishedDate(formatString: "DD MMMM, YYYY")
                createdAt
                type {
                    id: contentful_id
                }
                channel {
                    slug
                    name
                }
                community {
                    id: contentful_id
                }
            }
        }
        contentfulProducts: allContentfulCategoryPage(
            filter: {pageTitleCardTitle: {eq: "Shop All"}, products: {elemMatch: {visibleInMenu: {eq: true}, node_locale: {eq: "en-US"}}}}
        ) {
            edges {
                node {
                    id
                    products {
                        displayName
                        wildSectionTagSlug
                    }
                    node_locale
                }
            }
            totalCount
        }
    }
`;
